import request from "../utils/request";

export function getConfigs() {
    return request({
        url: '/api/config/company'
    })
}

export function setConfigs(configs) {
    return request({
        url: '/api/config/set',
        method: 'post',
        data: {
            configs
        }
    })
}